import { Link } from "supercell-frontend-base/src/components/article/navigation/link";

import { getArticleIndex } from "supercell-frontend-base/src/utils/articles/get-article-index";
import { isOnEsportsTab } from "supercell-frontend-base/src/utils/articles/is-on-tab";

export const getProps =
    (id: string, isolated: boolean) =>
    ({ articles, globals }: { articles: any; globals: any }) => {
        const newsArticles = articles.filter(isOnEsportsTab);

        const index = getArticleIndex(newsArticles, id);

        const article = newsArticles[index];
        const nextArticle = newsArticles[index - 1];
        const prevArticle = index > -1 && newsArticles[index + 1];

        const prevLinkProps = !isolated
            ? {
                  disabled: !prevArticle,
                  label: globals["globalText.langOlder"],
                  labelComponentProps: {
                      data: prevArticle as any,
                  },
              }
            : undefined;

        const nextLinkProps = !isolated
            ? {
                  next: true,

                  disabled: !nextArticle,
                  label: globals["globalText.langNewer"],
                  labelComponentProps: {
                      data: nextArticle as any,
                  },
              }
            : undefined;

        return {
            article,
            Link,
            prevLinkProps,
            nextLinkProps,
        };
    };
